import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { WhatsappCampaign } from '@core/models/whatsapp-campaign.model';

@Injectable()
export class WhatsappCampaignEntityService extends EntityCollectionServiceBase<WhatsappCampaign> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('WhatsappCampaign', serviceElementsFactory);
  }
}
